export default function SafetySection() {
  return (
    <section id="safety" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 text-center mb-4">
          Czy Kakobuy jest bezpieczny?
        </h2>
        <div className="flex justify-center mb-8">
          <div className="w-16 h-1 bg-accent-500 rounded-full"></div>
        </div>
        <p className="text-base md:text-lg text-foreground-700 leading-relaxed text-center max-w-2xl mx-auto mb-12">
          Bezpieczeństwo zakupów online jest najważniejsze. Dlatego przygotowaliśmy
          kompletny przewodnik, który pomaga użytkownikom sprawdzić produkty,
          sprzedawców oraz koszty wysyłki.
        </p>

        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-800 whitespace-nowrap">Element</th>
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-800 whitespace-nowrap">Sprawdź</th>
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-800 whitespace-nowrap">Ryzyko</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-background-200/60">
              <tr className="hover:bg-background-100/50 transition-colors">
                <td className="px-5 py-3.5 text-foreground-800 font-medium whitespace-nowrap">Sprzedawca</td>
                <td className="px-5 py-3.5 text-foreground-600 whitespace-nowrap">Opinie i oceny</td>
                <td className="px-5 py-3.5 whitespace-nowrap">
                  <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-800">
                    Fałszywy produkt
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-background-100/50 transition-colors">
                <td className="px-5 py-3.5 text-foreground-800 font-medium whitespace-nowrap">Zdjęcia QC</td>
                <td className="px-5 py-3.5 text-foreground-600 whitespace-nowrap">Jakość wykonania</td>
                <td className="px-5 py-3.5 whitespace-nowrap">
                  <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-800">
                    Niska jakość
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-background-100/50 transition-colors">
                <td className="px-5 py-3.5 text-foreground-800 font-medium whitespace-nowrap">Cena</td>
                <td className="px-5 py-3.5 text-foreground-600 whitespace-nowrap">Porównanie rynkowe</td>
                <td className="px-5 py-3.5 whitespace-nowrap">
                  <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-800">
                    Podejrzanie tanio
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-background-100/50 transition-colors">
                <td className="px-5 py-3.5 text-foreground-800 font-medium whitespace-nowrap">Wysyłka</td>
                <td className="px-5 py-3.5 text-foreground-600 whitespace-nowrap">Koszt i czas</td>
                <td className="px-5 py-3.5 whitespace-nowrap">
                  <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-800">
                    Ukryte opłaty
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}